import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "@platform/api";
import { Alert } from "@platform/design-system";

import { Loader } from "../../components";
import { extractErrorMessage } from "../../utils";

import BrokerPartners from "./brokerPartners";
import { BrokerPartner } from "./types";

function ManageBrokers(): React.JSX.Element {
  const axiosInstance = useApi();

  const { data, isLoading, isError, error } =
    useQuery<PrepareManageBrokersResponse>({
      queryKey: ["prepareManageBrokers"],
      queryFn: () =>
        axiosInstance
          .get<PrepareManageBrokersResponse>(
            "/brokerportal/v1/prepareManageBrokers",
          )
          .then((resp) => resp.data),
    });

  if (isError) {
    return (
      <Box mt={2} mb={2}>
        <Alert severity="error">{extractErrorMessage(error)}</Alert>
      </Box>
    );
  }

  if (isLoading) {
    return <Loader />;
  }

  return <BrokerPartners brokers={data} />;
}

type PrepareManageBrokersResponse = BrokerPartner[];

export { ManageBrokers };
